<div class="robot-rules-container rate">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.condition" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "automation.rate_rule.condition.label.score" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-checkbox-group [(ngModel)]="listOfStarOption"></nz-checkbox-group>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="scopeChannels"
              (ngModelChange)="onSelectChannels($event)"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelOption"></nz-select>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel_account" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="scopeAccounts"
              (ngModelChange)="onSelectAccounts($event)"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelAccountOption"></nz-select>
          </div>
        </div>
      </div>

      <widget-rule-form-item-house-picker
        [data]="$any(scopeHouses)"
        (onChange)="scopeHouses = $event"></widget-rule-form-item-house-picker>
    </div>
  </div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.rate.title.action" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.action.label_content" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row relative">
            <textarea
              #textarea
              class="pb-[40px]"
              nz-input
              nzAutosize
              rows="6"
              [placeholder]="'robot.rule.action.placeholder_content' | translate"
              [(ngModel)]="actionTextContent"
              [disabled]="actionQuickMsgId !== null"></textarea>
            <div class="absolute bottom-[1px] left-[10px] right-[20px] pb-[10px] bg-white">
              <host-dyn-content-picker
                [listOfDynContentOption]="listOfDynContentOption"
                (onSelect)="onSelectDynContent($event)"></host-dyn-content-picker>
            </div>
          </div>
          <div class="v4-layout-field-extra flex flex-row items-center">
            <div class="w-[150px]">
              <host-rate-tpl-picker (onSelect)="onSelectQuickMsgOfAction($event)"></host-rate-tpl-picker>
            </div>
            <span class="tip ml-3">{{ "automation.rate_rule.condition.tip1" | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row items-center justify-between pt-[30px]">
    <div class="left"></div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nz-button nzSize="large" nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
    </div>
  </div>
</div>
